"use strict";

var _toConsumableArray = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _createForOfIteratorHelper = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ErrorReplacerJSON_1 = require("@opengsn/common/dist/ErrorReplacerJSON");

var GSNContractsDataTypes_1 = require("@opengsn/common/dist/types/GSNContractsDataTypes");

var RelaySelectionManager = /*#__PURE__*/function () {
  function RelaySelectionManager(gsnTransactionDetails, knownRelaysManager, httpClient, pingFilter, logger, config) {
    _classCallCheck(this, RelaySelectionManager);

    this.remainingRelays = [];
    this.isInitialized = false;
    this.errors = new Map();
    this.gsnTransactionDetails = gsnTransactionDetails;
    this.knownRelaysManager = knownRelaysManager;
    this.httpClient = httpClient;
    this.pingFilter = pingFilter;
    this.config = config;
    this.logger = logger;
  }
  /**
   * Ping those relays that were not pinged yet, and remove both the returned relay or relays re from {@link remainingRelays}
   * @returns the first relay to respond to a ping message. Note: will never return the same relay twice.
   */


  _createClass(RelaySelectionManager, [{
    key: "selectNextRelay",
    value: function () {
      var _selectNextRelay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(paymaster) {
        var slice, relayInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!true) {
                  _context.next = 12;
                  break;
                }

                slice = this._getNextSlice();
                relayInfo = void 0;

                if (!(slice.length > 0)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return this._nextRelayInternal(slice, paymaster);

              case 6:
                relayInfo = _context.sent;

                if (!(relayInfo == null)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("continue", 0);

              case 9:
                return _context.abrupt("return", relayInfo);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function selectNextRelay(_x) {
        return _selectNextRelay.apply(this, arguments);
      }

      return selectNextRelay;
    }()
  }, {
    key: "_nextRelayInternal",
    value: function () {
      var _nextRelayInternal2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(relays, paymaster) {
        var raceResult, managerAddress, events, relayInfo;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.logger.info('nextRelay: find fastest relay from: ' + JSON.stringify(relays));
                _context2.next = 3;
                return this._raceToSuccess(relays, paymaster);

              case 3:
                raceResult = _context2.sent;
                this.logger.info("race finished with a result: ".concat(JSON.stringify(raceResult, ErrorReplacerJSON_1.replaceErrors)));

                this._handleRaceResults(raceResult);

                if (!(raceResult.winner != null)) {
                  _context2.next = 23;
                  break;
                }

                if (!GSNContractsDataTypes_1.isInfoFromEvent(raceResult.winner.relayInfo)) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt("return", raceResult.winner);

              case 11:
                managerAddress = raceResult.winner.pingResponse.relayManagerAddress;
                this.logger.info("finding relay register info for manager address: ".concat(managerAddress, "; known info: ").concat(JSON.stringify(raceResult.winner.relayInfo)));
                _context2.next = 15;
                return this.knownRelaysManager.getRelayInfoForManagers(new Set([managerAddress]));

              case 15:
                events = _context2.sent;

                if (!(events.length === 1)) {
                  _context2.next = 22;
                  break;
                }

                // as preferred relay URL is not guaranteed to match the advertised one for the same manager, preserve URL
                relayInfo = events[0];
                relayInfo.relayUrl = raceResult.winner.relayInfo.relayUrl;
                return _context2.abrupt("return", {
                  pingResponse: raceResult.winner.pingResponse,
                  relayInfo: relayInfo
                });

              case 22:
                throw new Error('Could not find register event for the winning preferred relay');

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _nextRelayInternal(_x2, _x3) {
        return _nextRelayInternal2.apply(this, arguments);
      }

      return _nextRelayInternal;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.knownRelaysManager.getRelaysSortedForTransaction(this.gsnTransactionDetails);

              case 2:
                this.remainingRelays = _context3.sent;
                this.isInitialized = true;
                return _context3.abrupt("return", this);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }() // relays left to try
    // (note that some edge-cases (like duplicate urls) are not filtered out)

  }, {
    key: "relaysLeft",
    value: function relaysLeft() {
      return this.remainingRelays.flatMap(function (list) {
        return list;
      });
    }
  }, {
    key: "_getNextSlice",
    value: function _getNextSlice() {
      if (!this.isInitialized) {
        throw new Error('init() not called');
      }

      var _iterator = _createForOfIteratorHelper(this.remainingRelays),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var relays = _step.value;
          var bulkSize = Math.min(this.config.sliceSize, relays.length);
          var slice = relays.slice(0, bulkSize);

          if (slice.length === 0) {
            continue;
          }

          return slice;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return [];
    }
    /**
     * @returns JSON response from the relay server, but adds the requested URL to it :'-(
     */

  }, {
    key: "_getRelayAddressPing",
    value: function () {
      var _getRelayAddressPing2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(relayInfo, paymaster) {
        var pingResponse;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.logger.info("getRelayAddressPing URL: ".concat(relayInfo.relayUrl));
                _context4.next = 3;
                return this.httpClient.getPingResponse(relayInfo.relayUrl, paymaster);

              case 3:
                pingResponse = _context4.sent;

                if (pingResponse.ready) {
                  _context4.next = 6;
                  break;
                }

                throw new Error("Relay not ready ".concat(JSON.stringify(pingResponse)));

              case 6:
                this.pingFilter(pingResponse, this.gsnTransactionDetails);
                return _context4.abrupt("return", {
                  pingResponse: pingResponse,
                  relayInfo: relayInfo
                });

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _getRelayAddressPing(_x4, _x5) {
        return _getRelayAddressPing2.apply(this, arguments);
      }

      return _getRelayAddressPing;
    }()
    /**
     * From https://stackoverflow.com/a/37235207 (added types, modified to catch exceptions)
     * Accepts an array of promises.
     * Resolves once any promise resolves, ignores the rest. Exceptions returned separately.
     */

  }, {
    key: "_raceToSuccess",
    value: function () {
      var _raceToSuccess2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(relays, paymaster) {
        var _this = this;

        var errors;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                errors = new Map();
                _context5.next = 3;
                return new Promise(function (resolve) {
                  relays.forEach(function (relay) {
                    _this._getRelayAddressPing(relay, paymaster).then(function (winner) {
                      resolve({
                        winner: winner,
                        errors: errors
                      });
                    }).catch(function (err) {
                      errors.set(relay.relayUrl, err);

                      if (errors.size === relays.length) {
                        resolve({
                          errors: errors
                        });
                      }
                    });
                  });
                });

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function _raceToSuccess(_x6, _x7) {
        return _raceToSuccess2.apply(this, arguments);
      }

      return _raceToSuccess;
    }()
  }, {
    key: "_handleRaceResults",
    value: function _handleRaceResults(raceResult) {
      if (!this.isInitialized) {
        throw new Error('init() not called');
      }

      this.errors = new Map([].concat(_toConsumableArray(this.errors), _toConsumableArray(raceResult.errors)));
      this.remainingRelays = this.remainingRelays.map(function (relays) {
        return relays.filter(function (eventInfo) {
          var _a;

          return eventInfo.relayUrl !== ((_a = raceResult.winner) === null || _a === void 0 ? void 0 : _a.relayInfo.relayUrl);
        }).filter(function (eventInfo) {
          return !Array.from(raceResult.errors.keys()).includes(eventInfo.relayUrl);
        });
      });
    }
  }]);

  return RelaySelectionManager;
}();

exports.RelaySelectionManager = RelaySelectionManager;